import React from 'react';
import { Flex, Box } from 'grid-styled';
import P from '../P/P';
import Label from '../Label/Label';

class ListItem extends React.Component {
  render() {
    const {
      children,
      width,
      pt,
      metaData,
      content,
      parentItem,
      anotationList
    } = this.props;
    return (
      <Flex
        width={width ? width : 1 / 1}
        pt={pt ? pt : 3}
        pb={parentItem ? 0 : 3}
        flexWrap="wrap"
        alignItems="center"
        style={{ borderBottom: '1px solid rgb(241, 242, 245)' }}
      >
        <Flex width={[1, 4 / 7]} alignItems="center" pr={4}>
          {anotationList ? (
            <Box width={1}>
              {metaData && (
                <Label neutral tiny style={{ marginBottom: '7px' }}>
                  {metaData}
                </Label>
              )}
              <P bold neutral={metaData && metaData.length}>
                {content}
              </P>
            </Box>
          ) : (
            <Box width={1}>
              <P small bold style={{ marginBottom: '7px' }}>
                {metaData}
              </P>
              <P>{content}</P>
            </Box>
          )}
        </Flex>
        {children}
      </Flex>
    );
  }
}

export default ListItem;



// WEBPACK FOOTER //
// ./src/components/List/ListItem.js